import Infinite from "./components/Infinite";

export default Infinite;
